<template>
  <div>
    <div class="w-100 d-flex justify-content-end my-1">
      <b-button
        class="mr-1"
        variant="outline-success"
        @click="openModalLaborRegime({}, 1)"
      >
        <div class="d-flex justify-content-between">
          <span> {{ $t("CREATE") }} </span>
        </div>
      </b-button>
    </div>

    <filter-slot
      :filter="[]"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      :no-visible-principal-filter="true"
      @reload="$refs['ref-table-labor-regime'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-labor-regime"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(created_by)="data">
            <div>{{ data.full_name }}</div>
          </template>

          <template #cell(actions)="data">
            <div>
              <feather-icon
                icon="EditIcon"
                v-b-tooltip.hover.left="$t('Edit')"
                class="text-warning cursor-pointer ml-2"
                size="20"
                @click="openModalLaborRegime(data.item, 2)"
              />
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <modal-labor-regime
      v-if="showModal"
      @onlyClose="showModal = false"
      @closeReload="closeRefresh"
      :labor="currentLabor"
      :optionModal="optionModal"
    ></modal-labor-regime>
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import LaborRegimeService from "@/views/settings/views/payroll/components/labor-regime/service/labor-regime-service.js";
import ModalLaborRegime from "@/views/settings/views/payroll/components/labor-regime/components/ModalLaborRegime.vue";
export default {
  components: {
    FilterSlot,
    ModalLaborRegime,
  },
  computed: {
    fields() {
      return [
        {
          key: "name",
          sortable: false,
          label: this.$t("name"),
        },
        {
          key: "holidays",
          sortable: false,
          label: this.$t("holidays quantity"),
          tdClass: "ml-3",
        },
        {
          key: "full_name",
          sortable: false,
          label: this.$t("created by"),
        },
        {
          key: "updated_at",
          sortable: false,
          label: this.$t("updated at"),
        },
        {
          key: "actions",
          label: this.$t("actions"),
        },
      ];
    },
  },
  data() {
    return {
      showModal: false,
      optionModal: 1,
      currentLabor: null,

      isBusy: false,

      paginate: {
        from: 0,
        to: 0,
        of: 0,
        per_age: 10,
        current_age: 1,
      },
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
    };
  },
  methods: {
    async myProvider(ctx) {
      try {
        const params = {
          page: ctx.currentPage,
          per_page: ctx.perPage,
        };
        const { data } = await LaborRegimeService.getPaymentSetting(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },

    openModalLaborRegime(item, type) {
      this.currentLabor = item;
      this.optionModal = type;
      this.showModal = true;
    },

    closeRefresh: function () {
      this.showModal = false;
      this.$refs["ref-table-labor-regime"].refresh();
    },
  },
};
</script>

<style>
</style>